import { initializeApp } from "firebase/app"
import { getDatabase, ref, set, onValue ,push ,remove,update } from "firebase/database"
import {
    getFirestore,
    collection,
    getDocs,
    addDoc,
} from "firebase/firestore";
import {
    getAuth,
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signOut
} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBTTm_-3eKyz8sY6Zuqus-ugD0RSuRLmBI",
    authDomain: "text-to-be-copied.firebaseapp.com",
    databaseURL: "https://text-to-be-copied-default-rtdb.firebaseio.com",
    projectId: "text-to-be-copied",
    storageBucket: "text-to-be-copied.appspot.com",
    messagingSenderId: "128126758196",
    appId: "1:128126758196:web:4817e40f06a0b198f60961"
}

// Initialize Firebase and Firestore
const app = initializeApp(firebaseConfig);
// Get a reference to the database service
const db = getDatabase(app);
const db1 = getFirestore(app);
const auth = getAuth();

// 
export {
    db,
    ref,
    set,
    push,
    onValue,
    db1,
    collection,
    getDocs,
    addDoc,
    getAuth,
    signInWithEmailAndPassword,
    auth,
    onAuthStateChanged,
    signOut,
    remove,
    update
}